import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../../experiments/ExperimentParameterGroup';
import { FlowStateManager } from '../../flow-management/FlowStateManager';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
import { Step } from '../../views/Step';
export const BranchACQ133NewSteps = {
  name: 'BranchACQ133NewSteps',
  stateCheck: state => {
    return getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ133, [ExperimentParameterGroup.Variant_A]);
  },
  rebuildFlow: (flow, state, dispatch) => {
    const nextSteps = dispatch(FlowStateManager.replaceStep(Step.Name, Step.Name, Step.ProductExperience, Step.ProblemAwareness));
    return nextSteps;
  },
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: null
};